import { Component, Input, input, output, ChangeDetectionStrategy } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { TrimDirective } from "common/trim.directive";

@Component({
	selector: "stages-rdv-text-filter",
	templateUrl: "./text-filter.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, ReactiveFormsModule, TrimDirective, FormsModule],
})
export class TextFilterComponent {
	readonly identifier = input.required<string>();

	readonly activeFilters = input<Map<string, string>>(new Map<string, string>());

	readonly placeholder = input<string>("start.typing");

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	labelKey?: string;

	readonly keyUpFired = output<string>();

	onFilterKeyUp(value: string): void {
		this.keyUpFired.emit(value);
	}
}
